var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "delete-image") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Crear",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "crear/paso3/foto-adjuntada",
    transform: "translate(-89.000000, -240.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    transform: "translate(88.000000, 239.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "delete-image",
    transform: "translate(1.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11,22 C4.925,22 0,17.075 0,11 C0,4.925 4.924,0 11,0 C17.075,0 22,4.925 22,11 C22,17.075 17.076,22 11,22",
    id: "Fill-2",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1855,13.771 L12.4145,11 L15.1855,8.229 C15.5765,7.838 15.5765,7.205 15.1855,6.814 C14.7945,6.424 14.1625,6.424 13.7715,6.814 L10.9995,9.586 L8.2285,6.814 C7.8375,6.424 7.2055,6.424 6.8145,6.815 C6.4235,7.206 6.4235,7.838 6.8145,8.229 L9.5855,11 L6.8145,13.771 C6.4235,14.162 6.4235,14.795 6.8145,15.186 C7.2055,15.576 7.8375,15.576 8.2285,15.186 L10.9995,12.414 L13.7715,15.186 C14.1615,15.576 14.7945,15.576 15.1855,15.185 C15.5765,14.794 15.5765,14.162 15.1855,13.771",
    id: "Fill-4",
    fill: "#444444"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteImage);
export default __webpack_public_path__ + "static/media/delete-image.101962a661c6095d3ad6d4775b9eabf4.svg";
export { ForwardRef as ReactComponent };